import React, { useContext, useEffect, useState } from 'react'
import { capitalizeFirstLetter } from '../../Helpers/Api'
import { FaStar } from 'react-icons/fa'
import { TokenContext } from '../../Helpers/Hooks/TokenProvider'
import ContactTenant from '../Forms/ContactTenant'
import Property from '../Properties/Property'
import { Link } from 'react-router-dom'
import getUser from '../../mocks/users'
import { properties } from '../../mocks/properties'
export default function UserProfile ({ match }) {
  const [Token] = useContext(TokenContext)
  const [user, setUser] = useState({})
  const [Overlay, setOverlay] = useState({ shown: false, userInfo: {} })
  const [Bookings, setBookings] = useState([])
  const [Votes, setVotes] = useState([])

  useEffect(() => {
    setUser(getUser(match.params.idUser))
    setBookings([1])
    setVotes([
      {
        idVote: 1,
        avatar: 'renter.jpg',
        name: 'Alberto',
        lastName: 'Rodríguez',
        commentRenter: 'Muy buen inquilino.',
        voteValueRenter: 5
      },
      {
        idVote: 2,
        avatar: 'manu.jpg',
        name: 'Manuel',
        lastName: 'Torres',
        commentRenter: 'Un poco sucio tras la salida.',
        voteValueRenter: 2
      }
    ])
    return () => {
    }
  }, [match.params.idUser, Token])

  const propiedadUsuario = [{ ...properties[0] }]
  const buttonStyle =
    'select-none w-1/4 self-center text-center bg-principal-1 text-principal-gris border border-yellow-300 text-black py-2 px-3 hover:bg-gray-Primary hover:text-principal-1 transform ease-in duration-200 cursor-pointer'

  return (
    <>
      {Overlay.shown && (
        <ContactTenant
          setOverlay={setOverlay}
          info={Overlay.info}
          Token={Token}
        />
      )}
      <main className='flex flex-col items-center justify-center max-w-5xl py-20 pb-32 m-auto'>
        <div className='flex flex-col items-center justify-center perfil'>
          <article className='flex flex-col items-center justify-center gap-5 '>
            <img
              className='object-cover w-60 h-60 rounded-circle'
              src={
                user.avatar
                  ? `/Images/${user.avatar}`
                  : require('../../Images/defProfile.png').default
              }
              alt='imagen de perfil'
            />

            <section className=''>
              <div className='flex justify-between p-2 text-3xl bg-opacity-25 bg-gray-Primary text-principal-1'>
                <h1>
                  {user.name
                    ? `${capitalizeFirstLetter(
                        user.name
                      )} ${capitalizeFirstLetter(user.lastName)}`
                    : 'Nombre de tenant'}
                </h1>
              </div>
              <div className='flex self-center px-2 py-2'>
                {[1, 2, 3, 4, 5].map((value, i) => {
                  return (
                    <FaStar
                      key={value}
                      className='text-2xl duration-200 cursor-pointer text-principal-1'
                    />
                  )
                })}
              </div>
              <h2 className='w-full p-1 text-2xl font-semibold border-b border-gray-200 text-principal-gris bg-principal-1'>
                Biografía
              </h2>
              <p className='p-2'>
                {user.bio}
              </p>
            </section>
          </article>
        </div>

        <section className='w-full pt-2'>
          <h2 className='w-full p-1 text-2xl font-semibold border-b border-gray-200 text-principal-gris bg-principal-1'>
            Historial viviendas
          </h2>
          <div
            className='flex flex-col items-center gap-5 p-5 bookings-cont sm:justify-start sm:flex-row sm:flex-wrap lg:justify-start'
          >
            {Bookings.length
              ? (
                  Bookings.map((booking) => {
                    return (
                      <span key={1} className='max-w-xs'>
                        <article
                          className={`animate-fadeIn filter drop-shadow-xl h-1/3 max-w-xs flex flex-col items-start justify-between
                sm:w- sm:max-w-xs
                lg:flex-row lg:max-w-md lg:w-full`}
                        >
                          <div className='flex flex-col flex-grow w-full lg:w-5/12'>
                            <h2 className='w-full pl-2 text-lg bg-gray-Primary text-principal-1'>
                              {capitalizeFirstLetter('duplex')} en{' '}
                              {'Girona'}
                            </h2>
                            <p>
                              {'Carrer de Costa Rica'}, {'9'}
                            </p>
                            <p>Precio: {Number('300')}€</p>
                            <p>
                              Entrada:{' '}
                              {new Date(
                                '2020-05-01'
                              ).toLocaleDateString()}
                            </p>
                            <p>
                              Salida:
                              {new Date(
                                '2020-05-15'
                              ).toLocaleDateString()}
                            </p>
                          </div>
                          <div className='border-r-2 border-gray-700 border-opacity-75' />
                          <Link
                            to={`/alquileres/${2}`}
                            className='relative flex flex-col justify-between flex-grow w-full lg:h-40 lg:w-4/12'
                          >
                            <img
                              className='flex-grow object-cover w-full h-full'
                              src={
                            '/Images/flats/foto1.jpg'}
                              alt='alquiler'
                            />
                            <div className='flex justify-end w-full p-2 bg-gray-Primary'>
                              {Array(parseInt(3))
                                .fill(null)
                                .map((value, i) => {
                                  return (
                                          <FaStar
                                            key={i}
                                            className='text-principal-1'
                                          />
                                  )
                                })
                                  }
                            </div>
                          </Link>
                        </article>
                        {Bookings.length > 1 && (
                          <div className='w-full h-4 max-w-xs mt-5 separador bg-principal-1 sm:w-0' />
                        )}
                      </span>
                    )
                  })
                )
              : (
                <h2 className='p-2'>
                  Este inquilino no tiene historial de viviendas.
                </h2>
                )}
          </div>
        </section>
        <section className='w-full '>
          <h2 className='w-full p-1 text-2xl font-semibold border-b border-gray-200 text-principal-gris bg-principal-1'>
            Aquileres
          </h2>
          <div className='flex flex-wrap justify-center gap-5'>
            {propiedadUsuario.length > 0
              ? (
                  propiedadUsuario.map((property) => (
                    <Property key={property.idProperty} property={property}>
                      <div className='w-auto my-5 bg-white border border-black shadow-2xl cont-vivienda min-w-min '>
                        <img
                          className='w-auto max-w-xs'
                          src={require('../../Images/defPicture.jpg').default}
                          alt='default'
                        />
                        <div>
                          {property.city}
                          <br />
                          {property.province}
                          <br />
                          {property.adress}
                          <br />
                          {property.price}
                          <br />
                          <span className='flex'>
                            {Array(parseInt(property.votes))
                              .fill(null)
                              .map((value, i) => {
                                return (
                                  <FaStar
                                    key={i}
                                    className='text-principal-1'
                                  />
                                )
                              })}
                          </span>
                        </div>
                      </div>
                    </Property>
                  ))
                )
              : (
                <div className='p-2 font-medium'>No hay ningún inmueble.</div>
                )}
          </div>
        </section>

        <section className='w-full pb-20'>
          <h2 className='w-full p-1 text-2xl font-semibold border-b border-gray-200 text-principal-gris bg-principal-1'>
            Opiniones
          </h2>
          <div className='flex flex-col items-center justify-center w-full gap-5 pt-5 votes-cont sm:flex-row sm:flex-wrap'>
            {Votes.length
              ? (
                  Votes.map((vote) => {
                    return (
                      <article
                        className='flex w-10/12 max-w-xs shadow-xl'
                        key={vote.idVote}
                      >
                        <img
                          className='m-2 rounded-full w-14 h-14'
                          src={
                        vote.avatar
                          ? '/Images/' + vote.avatar
                          : require('../../Images/defProfile.png').default
                      }
                          alt='imagen de perfil'
                        />
                        <section className=''>
                          <h1 className='font-bold'>
                            {vote.name} {vote.lastName}
                          </h1>
                          <p className=''>{vote.commentRenter}</p>
                          <div className='flex self-center py-2 text-xs'>
                            {vote.voteValueRenter > 0
                              ? (
                                  Array(parseInt(vote.voteValueRenter))
                                    .fill(null)
                                    .map((value, i) => {
                                      return (
                                        <FaStar
                                          key={i}
                                          className='text-xl text-principal-1'
                                        />
                                      )
                                    })
                                )
                              : (
                                <div className='h-4'>
                                  <FaStar className='text-gray-200' />
                                </div>
                                )}
                          </div>
                        </section>
                      </article>
                    )
                  })
                )
              : (
                <p className='p-2 font-medium'>Aún no tiene valoraciones</p>
                )}
          </div>
        </section>

        <button
          className={buttonStyle + ''}
          onClick={() => {
            setOverlay({ shown: true, info: user, form: 'contact' })
          }}
        >
          Contactar
        </button>
      </main>
    </>
  )
}
